import React from "react";

import "./style.scss";

export const Squiggle = () => (
  <div className="squiggle">
    <img src="/images/squigglePurple.svg" alt="squiggle" />
  </div>
);
